// 公共列表数据模块
import {mngTypeList} from "@/api/chargeRecord";

const state = {
  mngTypeList: [], // 车辆管理类型的数据
};

const mutations = {

  GETMNGTYPE(state, data) {
    state.mngTypeList = data;
  },

};

const actions = {

  // 车辆管理类型列表数据
  async mngTypeListActions({ commit }) {
    let res = await mngTypeList();
    if (res.code === 200) {
      commit("GETMNGTYPE", res.data.list);
    }
  },


};

const getters = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
